import type { TLoansCalculationCustomerData } from 'shared/types/TLoansService';

import type { TCreditFormCommonFields } from 'entities/creditForm';
import {
  Additional,
  Addresses,
  Agreements,
  Auto,
  Contacts,
  CreditPurpose,
  Job,
  Passport,
} from 'entities/creditForm/lib/formatters';

// eslint-disable-next-line complexity
export const formDataToLoansCalculationCustomerAdapter = (
  formData: Partial<TCreditFormCommonFields>,
): Omit<TLoansCalculationCustomerData, 'calcId' | 'creditScore'> => {
  const auto = new Auto(formData).loans();
  const agreements = new Agreements(formData).profile();
  const passport = new Passport(formData).loans();
  const contacts = new Contacts(formData).loans();
  const creditPurpose = new CreditPurpose(formData).map();
  const addresses = new Addresses(formData).loans();
  const job = new Job(formData).loans();
  const additional = new Additional(formData).loans();

  return {
    ...additional,
    ...job,
    ...addresses,
    ...creditPurpose,
    ...contacts,
    ...passport,
    ...agreements,
    ...auto,
  };
};
